import * as Yup from "yup";
import CounterModel from "../../models/masters/counter-model";
import { API_END_POINT } from "../../constants";
import { InputField } from "../../components/form/input.field.component";
import { FormikModelDialog, SubmitStatus } from "../../core/formik-model-dialog.component";
import { CheckboxField, CheckBoxStyle } from "../../core/checkbox-field.component";
import { useEffect, useState } from "react";
import { useGetDistrict } from "../../apiclient/master/useGetDistrictApi";
import { SelectField } from "../../core/select-field.component";
import { useGetCounter } from "../../apiclient/master/useGetCounterApi";
import { useGetZones } from "../../apiclient/master/useGetZoneApi";

interface CounterEditProps {
  data: CounterModel;
  isViewMode?: boolean;
  
  onClose?: (status: SubmitStatus, data: any) => any;
}

const CounterEntry: React.FC<CounterEditProps> = ({ ...props }) => {
  let { data,  onClose,isViewMode } = props;
  const title = data?.counterId > 0 ? "Edit Counter" : "Add Counter";
  
  let initialValue: CounterModel = {
    counterId: data?.counterId ? data.counterId : 0,
    name: data?.name,
    isActive: data?.counterId > 0 ? data.isActive : true,
    zoneId: data?.zoneId ? data.zoneId : 0,
    zoneName: data?.zoneName,
    acCode: data?.acCode,
    isCashCollection: data?.isCashCollection,
   
  };
  const validationSchema = Yup.object().shape({
    // name: Yup.string().required("Required"),
    name: Yup.string()
    .required("Required")
    .test("check-duplicate-name", "Counter name already exists", (value) => {
      // Ensure the value is compared in a case-insensitive manner
      return (
        value &&
        !existingName.some(existing => existing.toLowerCase() === value.toLowerCase()) ||
        (data?.name && value === data.name) // Allow current name during update
      );
    }), 


  });

    const [existingName, setExistingName] = useState<string[]>([]);
    const { data: fetchedCounter } = useGetCounter();



  const [zoneData, setZoneData] = useState<{ value: string; label: string }[]>([]);
  const { data: fetchedZone } = useGetZones();

  useEffect(() => {
    if (fetchedCounter) {
        setExistingName(fetchedCounter.map((cat: any) => cat.name));
    }


      if (fetchedZone) {
          const mappedZone = fetchedZone.map((zone: any) => ({
              value: zone.zoneId.toString(),
              label: zone.name,
          }));
          setZoneData(mappedZone);
      }
  }, [fetchedZone,fetchedCounter]);

  
  return (
    <>
      <FormikModelDialog
        width="50%"
        title={title}
        initialData={initialValue}
        validationSchema={validationSchema}
        show={!!data}
        onClose={onClose}
        endpoint={API_END_POINT.MASTER}
        postRoute="Counter/SaveCounter"
        showAddAnother={true}
        isUpDateEntityDetails={data?.counterId>0? true: false}
        isViewOnly ={isViewMode}
      >
          <div>
            <div className="row">
              <div className="col-6">
              <InputField maxLength={10} label="Counter *" name="name" />
            </div>
            <div className="col-6">
                     <SelectField
                                label="Zone"
                                name="zoneId"
                                options={zoneData}
                                unSelectValue={0}
                            />       
                                 </div>
                                 <div className="col-12">

                                <div className="col-6">
                              <InputField maxLength={10} 
                              label="Ac Code"
                               name="acCode" />
                              </div>
                              </div>

                              <div className="col-4">
                             <CheckboxField
                             label="Is Active ?"
                              name="isActive"
                              checkstyle={CheckBoxStyle.Normal}
                  />
                               </div>


                            <div className="col-4">
                            <CheckboxField
                            label="Is Cash Commission?"
                            name="isCashCollection"
                          checkstyle={CheckBoxStyle.Normal}
                  />
              </div>
                                 
                
              
            </div>
          </div>
        
      </FormikModelDialog>
    </>
  );
};

export default CounterEntry;
